export default __webpack_public_path__ + "static/media/tmp_inspection_station.dd991e24.png";